import { ProductionSpeedStepDto, StepEnum } from '@/api-sdk';
import { Step } from '@/types';

/**
 * Checks if the 'hsp' option is enabled in the given steps.
 *
 * This function iterates through an array of `StepDto` objects to find a step
 * of type `PRODUCTION_SPEED`. If such a step is found and it contains options,
 * it checks if any of the options are selected and have a code of 'hsp'.
 *
 * @param steps - An array of step data transfer objects.
 * @returns Returns `true` if the 'hsp' option is enabled, otherwise `false`.
 */
export const getHspEnabled = (steps: Step[]): boolean => {
  const productionSpeedStep = steps.find(
    step => step.type === StepEnum.production_speed,
  ) as ProductionSpeedStepDto | undefined;
  if (productionSpeedStep && productionSpeedStep?.options) {
    const selectedOption = productionSpeedStep.options.find(
      option => option.selected,
    );
    return selectedOption?.code === 'hsp';
  }
  return false;
};
